const o = () => ({
  infoIcon: {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent"
    }
  }
}), n = o;
export {
  n as default
};
